import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import { Collapse, TableCell, TableRow } from '@mui/material';

import { selectAttendedStatusId } from '../../../store/dataSelectors';
import { reverseFormatDate } from '../../../utils/dateFunctions';

import CurrentCourseDetails from './CurrentCourseDetails';

import classes from '../../../commonStyles/tables.module.css';

const styles = {
    paddingBottom: 0,
    paddingTop: 0,
    paddingLeft: 0,
    paddingRight: 0,
    borderTop: 'none',
    borderBottom: 'none'
};

const CurrentCourseTableRow = ({
    row,
    toggleDropdown,
    openId,
    isDisabled,
    isSelfEmployedCoach
}) => {
    // LOCAL STATE
    const [open, setOpen] = useState(null);
    const [numberAttendedModules, setNumberAttendedModules] = useState(0);

    // STORE STATE
    const currentParticipant = useSelector(
        (state) => state.entities.participantService.currentParticipant
    );
    const attendedStatusId = useSelector(selectAttendedStatusId);

    // USEEFFECTS
    useEffect(() => {
        const participantsModules = row?.modules.filter((el) =>
            el.participants.find(
                (entry) =>
                    entry.participantId === currentParticipant.id &&
                    entry.statusId === attendedStatusId
            )
        );
        setNumberAttendedModules(participantsModules.length);
    }, [row?.modules]);

    useEffect(() => {
        if (openId !== row.id) setOpen(null);
    }, [openId]);

    // EVENT HANDLERS
    const onToggleDropdown = () => {
        toggleDropdown(row.id);
        setOpen(open === row.id ? null : row.id);
    };

    return (
        <>
            <TableRow
                hover
                className={`${classes.tableRowStripes} ${classes.oldLace} ${classes.canOpen}`}
                onClick={onToggleDropdown}>
                <TableCell>{row.code}</TableCell>
                <TableCell>{row.name}</TableCell>
                <TableCell>{reverseFormatDate(row.startDate)}</TableCell>
                <TableCell>{reverseFormatDate(row.endDate)}</TableCell>
                <TableCell style={{ fontWeight: 'bold', paddingLeft: '32px' }}>
                    {`${numberAttendedModules}/${row.modules?.length}`}
                </TableCell>
            </TableRow>
            <TableRow>
                <TableCell style={styles} colSpan={5}>
                    <Collapse in={open === row.id} timeout="auto" unmountOnExit>
                        <CurrentCourseDetails
                            row={row}
                            onClose={() => setOpen(null)}
                            isDisabled={isDisabled}
                            isSelfEmployedCoach={isSelfEmployedCoach}
                        />
                    </Collapse>
                </TableCell>
            </TableRow>
        </>
    );
};

CurrentCourseTableRow.propTypes = {
    row: PropTypes.object,
    openId: PropTypes.string,
    toggleDropdown: PropTypes.func,
    isDisabled: PropTypes.bool,
    isSelfEmployedCoach: PropTypes.bool
};

export default CurrentCourseTableRow;
